import PropTypes from 'prop-types';

import styles from './SearchBarPanel.scss';

export function SearchBarPanel(props) {
  const {
    id,
    children,
  } = props;

  return (
    <div className={styles.root} id={id}>
      {children}
    </div>
  );
}

SearchBarPanel.propTypes = {
  children: PropTypes.any,
  id: PropTypes.string,
};
